module.exports = __webpack_public_path__ + "img/78.5d4f4da4.jpg";